import { ScreenFullIcon } from '@primer/octicons-react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ScreenFullIcon,
  PropTableValues,
  React
};